import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { addUser } from "../../../services/api/userAdministration.api";
import { TextField, FormControl, FormLabel, Button, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { showSnack } from "../../../utils/component";

interface UserAddProps {
	//Method sets the user name on the page component that allows the page
	//to rerender when a username is successfully added.
	setUserName: (userName: string) => void;
}

const useStyles = makeStyles((theme) => ({
	titleWrapper: {
		maxWidth: theme.breakpoints.values.md,
		display: "flex",
		justifyContent: "space-between",
	},
	title: {
		marginBottom: theme.spacing(3),
	},
	list: {
		maxWidth: theme.breakpoints.values.md,
		maxHeight: 700,
	},
	formControl: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		marginTop: "9px",
	},
	formControlLabel: {
		fontSize: theme.typography.caption.fontSize,
		margin: 0,
	},
	inputField: {
		width: 320,
		marginBottom: 0,
		marginTop: "11px",
	},
}));

/**
 * Displays a text input field and a submit button to add a new user to the db.
 */
export const UserAdd = (props: UserAddProps) => {
	const classes = useStyles();
	const [userName, setUserName] = React.useState("");
	const { enqueueSnackbar } = useSnackbar();

	const submit = async () => {
		try {
			await addUser(userName)();

			window.history.pushState({}, "", window.location.origin + "/Administration/Users/" + userName);
			showSnack(enqueueSnackbar, "Successfully Added User to Database.", "success");
			props.setUserName(userName);
		} catch (ex) {
			console.log(ex);
			showSnack(enqueueSnackbar, "Failed To Add User to Database.", "error");
		}
	};

	return (
		<div>
			<div className={classes.titleWrapper}>
				<Typography className={classes.title} variant="h4" data-testid="user-add-title">
					New User
				</Typography>
			</div>
			<div data-testid={"user-name-edit-field"}>
				<FormControl className={classes.formControl}>
					<FormLabel className={classes.formControlLabel}>User Principal Name</FormLabel>
					<TextField
						className={classes.inputField}
						value={userName}
						margin="normal"
						onChange={(e) => setUserName(e.target.value)}
					/>
				</FormControl>
			</div>
			<div style={{ float: "right", paddingRight: 75 }} data-testid="submit-changes-button">
				<Button
					disabled={userName.length === 0}
					size="small"
					variant="outlined"
					color="primary"
					onClick={() => submit()}
				>
					Submit Changes
				</Button>
			</div>
		</div>
	);
};
